<template>
  <div class="checkout-extrasell-product pt-4">
    <template v-if="showRetry">
      <div class="retry-payment-form" v-if="showpaymentform">
        <PaymentForm
          :paymentMethodsOptions="{
            sepa: { cssClass: 'field-icon fa-solid fa-building-columns' },
            bank_card: { cssClass: 'field-icon fa-solid fa-credit-card' },
            iframeStyle: 'orderPage',
          }"
        />
      </div>
      <button
        type="button"
        class="skip-process-btn"
        @click.prevent="(event) => skipProcessAction(event)"
      >
        {{ $t("labels.skipProcess") }}
      </button>
    </template>
    <template v-else>
      <!-- for debugging should be removed after tests -->
      <!-- {{ stepType }} - {{ step }} -->
      <!-- /for debugging should be removed after tests -->

      <ProductExtraProducts
        v-if="products"
        :postMountedProducts="products"
        :showaddtocart="showaddtocart"
        :showprocessorder="showprocessorder"
        :step="step"
        :showBeforeText="true"
        :showAfterText="true"
      />
    </template>

    <div class="minicart-content" v-if="stepType === 'postUpsells'">
      <div class="cart-table">
        <CartTable />
      </div>
      <div class="cart-totals">
        <CartTotals />
      </div>
      <div class="action">
        <!-- TODO : implement flow order upsell's type or else it will just create a new initial order -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useOrderHistoryStore } from "@/store/orderHistory";
import ProductExtraProducts from "@/components/product/ExtraProducts.vue";
import AbTests from "@/services/abTests";
import CartFreeShippingProgression from "@/components/cart/FreeShippingProgression.vue";
import CartTable from "@/components/cart/Table.vue";
import CartCoupon from "@/components/cart/Coupon.vue";
import CartTotals from "@/components/cart/Totals.vue";
import CartProcess from "@/components/cart/Process.vue";
import CartService from "@/services/cart";
import Redirect from "@/services/redirect";
import Utils from "@/services/utils";
import { useDraftStore } from "@/store/draft";
import Orion from "@/services/orion";
import { useCartStore } from "@/store/cart";
import { constants } from "@/constants";
import PaymentForm from "@/components/checkout/PaymentForm.vue";
import { useTrackingStore } from "@/store/tracking";

export default {
  name: "CheckoutExtrasell",
  components: {
    ProductExtraProducts,
    CartFreeShippingProgression,
    CartTable,
    CartCoupon,
    CartTotals,
    CartProcess,
    PaymentForm,
  },
  data() {
    return {
      step: 0,
      stepType: null,
      products: null,
      showprocessorder: false,
      showaddtocart: false,
      showRetry: false,
      showpaymentform: false,
      retryOrderId: null,
      retryItem: null,
      newRetryOrderId: null,
      newRetryOrder: null,
    };
  },
  computed: {
    historyLastUpdate() {
      return useOrderHistoryStore().lastUpdate;
    },
    selectedPaymentMethod() {
      return useDraftStore().selectedPaymentMethod;
    },
  },
  async mounted() {
    const queryStringData = Object.fromEntries(
      new URL(window.location).searchParams,
    );
    this.retryOrderId = queryStringData.retry;

    if (this.retryOrderId) {
      this.retryItem = useOrderHistoryStore().orderHistory.find(
        (item) => item.order.externalOrderId === this.retryOrderId,
      );
      if (this.retryItem.order.orderType === "crosssell") {
        this.step = this.retryItem.step;
      }

      if (this.retryItem) {
        // loop over previous cart items to add them to the new cart
        await this.buildCart();

        this.buildNewRetryOrder();

        useDraftStore().selectPaymentMethod(this.retryItem.order.paymentType);

        // send new order based on previous one
        //await this.sendRetryDraftOrder(); // not needed : selectPaymentMethod will do it

        useDraftStore().formValid(true);

        this.showRetry = true;
        this.showpaymentform = true;
      }
    } else {
      await this.callLambda();

      const previousPaymentType =
        useOrderHistoryStore().orderHistory.slice(-1)[0].order.paymentType;
      useDraftStore().selectPaymentMethod(previousPaymentType);
    }
  },
  watch: {
    historyLastUpdate: {
      handler(newValue, oldValue) {
        if (!window?.globalConfig?.domainId) {
          return;
        }
        if (this.retryOrderId) {
          return;
        }

        this.callLambda();
      },
    },
    selectedPaymentMethod: {
      handler(newValue, oldValue) {
        if (this.retryOrderId) {
          this.sendRetryDraftOrder();
        }
      },
    },
  },
  methods: {
    async buildCart() {
      let productFiles = [];

      for (const oldCartItem of this.retryItem.cart.items) {
        const newCartItem = window.productDetails;

        const choiceId = oldCartItem.choice.id;
        newCartItem.choice = newCartItem.choices.find(
          (choice) => choice.id === choiceId,
        );
        newCartItem.qtyIncr = 1;
        newCartItem.qty = oldCartItem.qty;

        CartService.addToCart(newCartItem);
      }
    },
    buildNewRetryOrder() {
      this.newRetryOrder = Object.assign({}, this.retryItem.order);
      // keep the previous orderId from the original element
      if (!this.newRetrOrderId) {
        this.newRetrOrderId = Utils.generateUID();
      }
      this.newRetryOrder.externalOrderId = this.newRetrOrderId;
      this.newRetryOrder.status = "pending";
      this.newRetryOrder.isPaymentCaptured = false;
      this.newRetryOrder.isRetry = true;

      useDraftStore().updateOrder(this.newRetryOrder);
    },
    async sendRetryDraftOrder() {
      useDraftStore().sendingDraftOrder(true);

      const preparedOrder = Orion.prepareOrder(
        useCartStore().cart,
        this.newRetryOrder,
      );
      useDraftStore().updateOrder(preparedOrder);

      useDraftStore().sendingDraftOrder(false);

      console.log("ProcessOrderPreparedOrder", preparedOrder);

      const minifiedCart = CartService.minifyCart();

      await Orion.sendOrder(
        minifiedCart,
        preparedOrder,
        window.globalConfig.domainId,
      );

      useOrderHistoryStore().removeRetryOrders();
      useOrderHistoryStore().addOrderToHistory(
        useCartStore().cart,
        preparedOrder,
        this.step,
      );

      useDraftStore().draftOrderSent(true);
    },
    async callLambda() {
      const payload = this.buildPayload();
      const url = `${process.env.VUE_APP_ORION_API_BASE_URL}/extrasell`;
      const lambdaResult = await this.doCall(url, payload);
      console.log("lambdaResult", lambdaResult.data);
      if (lambdaResult.data) {
        this.step = lambdaResult.data.step;
        this.stepType = lambdaResult.data.stepType;

        if (this.stepType === "crossSells") {
          this.products = this.findCrossSellsChoices(
            lambdaResult.data.productDetails,
          );
          this.showprocessorder = true;
          this.showaddtocart = false;
        } else if (this.stepType === "postUpsells") {
          this.products = this.findUpsellChoices(
            lambdaResult.data.productDetails,
          );
          this.showprocessorder = false;
          this.showaddtocart = true;
        } else {
          // empty products (skip step)
          this.products = null;
        }
      }
    },

    buildPayload() {
      const historyFromStorage = useOrderHistoryStore().orderHistory;

      const payload = {};
      payload.domainId = window.globalConfig.domainId;

      payload.history = [];
      for (const historyItem of historyFromStorage) {
        const history = {};
        history.step = historyItem.step;
        history.stepType = historyItem.stepType;

        history.choices = [];
        for (const cartItem of historyItem.cart.items) {
          const historyChoice = {};
          historyChoice.productDetailsId = cartItem.id;
          historyChoice.qty = cartItem.qty;
          historyChoice.choiceId = cartItem.choice.id;

          history.choices.push(historyChoice);
        }

        payload.history.push(history);

        this.step = historyItem.step; // last step
      }

      payload.currentStep = this.step;

      return payload;
    },
    doCall(url, payload) {
      return new Promise((resolve, reject) => {
        axios.post(url, payload).then(
          (response) => {
            resolve(response);
          },
          (error) => {
            console.error(error);
            reject(error);
          },
        );
      });
    },
    findUpsellChoices(productDetails) {
      const oldChoiceIds = [];
      const lastHistoryItem = useOrderHistoryStore().orderHistory.slice(-1)[0];
      for (const cartItem of lastHistoryItem.cart.items) {
        oldChoiceIds.push(cartItem.choice.id);
      }

      const upsellGroups = productDetails["postUpsells"].filter((choice) =>
        oldChoiceIds.includes(choice.parentId),
      );

      const electedUpsells = [];
      for (const upsellGroup of upsellGroups) {
        for (const upsellChoiceGroup of upsellGroup.children) {
          const electedItem = AbTests.electItemOfGroup(upsellChoiceGroup);
          electedUpsells.push(
            productDetails.choices.find(
              (choice) => choice.id === electedItem.id,
            ),
          );
        }
      }

      const products = [];
      for (const electedUpsell of electedUpsells) {
        const clonedProduct = JSON.parse(JSON.stringify(productDetails));
        electedUpsell.default = true; // mark as default
        clonedProduct.choices = [electedUpsell]; // override choices with only elected ones
        products.push(clonedProduct);
      }

      return products;
    },
    findCrossSellsChoices(productDetails) {
      // Step is already used by lambda to filter crossSells
      const crossSellsGroups = productDetails["crossSells"];

      const electedCrossSells = [];
      for (const crossSellGroup of crossSellsGroups) {
        const electedItem = AbTests.electItemOfGroup(crossSellGroup);
        const electedChoice = productDetails.choices.find(
          (choice) => choice.id === electedItem.id,
        );
        electedChoice.argument1 = electedItem.argument1;
        electedChoice.argument2 = electedItem.argument2;
        electedChoice.argument3 = electedItem.argument3;
        electedCrossSells.push(electedChoice);
      }

      const products = [];
      const electedCrossSell = electedCrossSells[0]; // only one crosssell

      const clonedProduct = JSON.parse(JSON.stringify(productDetails));
      electedCrossSell.default = true; // mark as default
      clonedProduct.choices = [electedCrossSell]; // override choices with only elected ones
      products.push(clonedProduct);

      return products;
    },

    skipProcessAction(event) {
      CartService.addToCartLoading(true);

      this.retryOrderId = null;
      this.showRetry = false;
      useOrderHistoryStore().addStepToHistory();

      CartService.addToCartLoading(false);
    },
  },
};
</script>
